import { isSubscriptionOrder } from '../../utils/order-type-utils';
import { getOrder } from '../order/get-order';
import { getOrderSelections } from '../order/get-order-selections';
export const getOrderSubscription = () => {
    const order = getOrder();
    const selectedSubscription = getOrderSelections().subscription;
    if (selectedSubscription)
        return selectedSubscription;
    return isSubscriptionOrder(order) ? order.subscription : undefined;
};
//# sourceMappingURL=get-order-subscription.js.map